import { render } from "./CxPointSetDetailsPanel.vue?vue&type=template&id=1b741876"
import script from "./CxPointSetDetailsPanel.vue?vue&type=script&lang=js"
export * from "./CxPointSetDetailsPanel.vue?vue&type=script&lang=js"

import "./CxPointSetDetailsPanel.vue?vue&type=style&index=0&id=1b741876&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__